import { Tab } from '../Tab';
import { TabButton } from '../TabButton';
import { TabsContainer } from '../TabsContainer';
import { StyledMenuContainer } from './MenuTabs.styled';

const MenuTabs = () => (
	<StyledMenuContainer>
		<TabButton>Q</TabButton>
		<TabsContainer>
			<Tab>Транспорт</Tab>
			<Tab>Недвижимость</Tab>
			<Tab>Номера</Tab>
		</TabsContainer>
		<TabButton>E</TabButton>
	</StyledMenuContainer>
);

export { MenuTabs };
